import { fromJS } from "immutable";
import {
  RoleUserAdmin,
  RoleCustomerService,
  RoleUploaderStaff,
  RoleUploaderSPV,
  RoleCSAgent,
  RoleCSSPV,
  keyIsLoggedIn,
  keyUserToken,
} from "../store/constants";
import Cookies from "universal-cookie";
import { func } from "prop-types";
import CryptoAES from "crypto-js/aes";
import CryptoENC from "crypto-js/enc-utf8";

const KeyUserLoginEnc = "OD&^%$";
const KeyUserMenuAccess = "OD$#%^";
const cookies = new Cookies();

function _GetObjectUserLogin() {
  var userLogin = getAppCookies();
  return userLogin;
}

function _IsUserLoggedIn() {
  if (_GetObjectUserLogin()) return true;
  else return false;
}

function _GetUserLoggedIn() {
  if (_IsUserLoggedIn()) {
    return fromJS(getAppCookies());
  }
  return fromJS({});
}

function _GetUserToken() {
  if (_IsUserLoggedIn()) {
    return fromJS(getAppCookies()).get("Token");
  }
}

function _GetClientID() {
  if (_IsUserLoggedIn()) {
    return fromJS(getAppCookies()).get("ClientId");
  }
}

function _GetSenderID() {
  if (_IsUserLoggedIn()) {
    return fromJS(getAppCookies()).get("SenderId");
  }
}

function _GetSenderName() {
  if (_IsUserLoggedIn()) {
    return fromJS(getAppCookies()).get("SenderName");
  }
}


function _GetDivisionId() {
  if (_IsUserLoggedIn()) {
    return fromJS(getAppCookies()).get("DivisionId");
  }
}

function _GetUserRole() {
  if (_IsUserLoggedIn()) {
    return fromJS(getAppCookies()).get("Role");
  }
}

function _GetUserPrevilage() {
  if (_IsUserLoggedIn()) {
    return fromJS(getAppCookies()).get("PrivilageId");
  }
}

function _GetUserMenuAccess() {
  if (_IsUserLoggedIn()) {
    return fromJS(getAppMenuCookies());
  }
}

export const IsLoggedIn = _IsUserLoggedIn();
export const UserLoggedIn = _GetUserLoggedIn();
export const UserToken = _GetUserToken();
export const UserRole = _GetUserRole();
export const ClientId = _GetClientID();
export const PrevilageId = _GetUserPrevilage();
export const DivisionId = _GetDivisionId();
export const SenderId = _GetSenderID();
export const SenderName = _GetSenderName();
export const UserMenuAccess = _GetUserMenuAccess();

//localhost, staging dev
// export const ApiUrl = "http://localhost:8060/api/";
// export const ApiUrl2 = "http://localhost:8060/api/";
// export const ApiUrl3 = "http://localhost:2727/apiHitFb/";
// export const ApiUrl4 = "http://10.0.7.96:9099/api/";
// export const ApiUrl5 = "http://localhost:1111/api/";
// export const ApiDashboard = "http://localhost:1111/api/";
// export const ApiUrlReportSession = "http://localhost:1111/api/"
// export const dummyUrlData = "http://10.0.7.96/testingRest/";
// export const ApiReport = "http://localhost:9191/apireport/";
// export const ApiQualityRating = "http://localhost:8015/apiquality/";
// export const ApiTemplate = "http://localhost:9988/apitemplate/";
// export const ApiListTemplate = "http://localhost:4921/apilisttemplate/";
// export const ApiBacklogClient = "http://localhost:9988/backlogclientapi/";
// export const ApiOnBoardMMLite = "http://localhost:8821/apionboardingmmlite/";
// export const ApiSmartMarketing = "http://43.133.156.44:8082/api/";

//SIT
// export const ApiUrl = "http://192.168.181.179:8060/api/";
// export const ApiUrl2 = "http://192.168.181.179:8060/api/";
// export const ApiUrl3 = "http://192.168.181.179:2727/apiHitFb/";
// export const ApiUrl4 = "http://192.168.181.179:9099/api/";
// export const ApiUrl5 = "http://192.168.181.179:1111/api/";
// export const ApiDashboard = "http://192.168.181.179:1111/api/";
// export const ApiUrlReportSession = "http://192.168.181.179:1111/apisession/";
// export const ApiReport = "http://192.168.181.179:9191/apireport/";
// export const ApiQualityRating = "http://192.168.181.179:8015/apiquality/";
// export const ApiTemplate = "http://192.168.181.179:9988/apitemplate/";
// export const ApiListTemplate = "http://192.168.181.179:4921/apilisttemplate/";
// export const ApiBacklogClient = "http://192.168.181.179:9988/backlogclientapi/";
// export const ApiOnBoardMMLite = "http://192.168.181.179:8821/apionboardingmmlite/";
// export const ApiSmartMarketing = "http://192.168.181.179:8082/api/";

//SITCPRO
// export const ApiUrl = "http://192.168.181.65:8060/api/";
// export const ApiUrl2 = "http://192.168.181.65:8060/api/";
// export const ApiUrl3 = "http://192.168.181.65:2727/apiHitFb/";
// export const ApiUrl4 = "http://192.168.181.65:9099/api/";
// export const ApiUrl5 = "http://192.168.181.65:1111/api/";
// export const ApiDashboard = "http://192.168.181.65:1111/api/";
// export const ApiUrlReportSession = "http://192.168.181.65:1111/apisession/";
// export const ApiReport = "http://192.168.181.65:9191/apireport/";
// export const ApiQualityRating = "http://192.168.181.65:8015/apiquality/";
// export const ApiTemplate = "http://192.168.181.65:9988/apitemplate/";
// export const ApiListTemplate = "http://192.168.181.65:4921/apilisttemplate/";
// export const ApiBacklogClient = "http://192.168.181.65:9988/backlogclientapi/";
// export const ApiOnBoardMMLite = "http://192.168.181.65:8821/apionboardingmmlite/";
// export const ApiSmartMarketing = "http://192.168.181.65:8082/api/";

//production
export const ApiUrl = "https://wabapro.satkomindo.com/api/";
export const ApiUrl2 = "https://wabapro.satkomindo.com/api/";
export const ApiUrl3 = "https://wabapro.satkomindo.com/apiHitFb/";
export const ApiUrl4 = "https://wabapro.satkomindo.com/api/";
export const ApiUrl5 = "https://wabapro.satkomindo.com/apianalytic/";
export const ApiDashboard = "https://wabapro.satkomindo.com/apianalytic/";
export const ApiUrlReportSession = "https://wabapro.satkomindo.com/apisession/";
export const ApiReport = "https://wabapro.satkomindo.com/apireport/";
export const ApiQualityRating = "https://wabapro.satkomindo.com/apiquality/";
export const ApiTemplate = "https://wabapro.satkomindo.com/apitemplate/";
export const ApiListTemplate = "https://wabapro.satkomindo.com/apilisttemplate/";
export const ApiBacklogClient = "https://wabapro.satkomindo.com/backlogclientapi/";
export const ApiOnBoardMMLite = "https://wabapro.satkomindo.com/apionboardingmmlite/";
export const ApiSmartMarketing = "https://wabapro.satkomindo.com/api/";

export function SetUserLogin(userLogin, data) {
  var userRole = RoleUserAdmin;

  var obj = {
    Token: userLogin.get("token"),
    FullName: userLogin.get("full-name"),
    PrivilageId: userLogin.get("privilege-id"),
    PrivilageName: userLogin.get("privilege-name"),
    DivisionId: userLogin.get("division-id"),
    DivisionName: userLogin.get("division-name"),
    ClientId: userLogin.get("client-id"),
    ClientName: userLogin.get("client-name"),
    SenderId : userLogin.get("sender-id"),
    SenderName : userLogin.get("sender"),
    Role: userRole,
  };
  debugger;
  var access = fromJS({});
  if (data !== undefined && data.get("data") !== undefined) {
    // eslint-disable-next-line array-callback-return
    data.get("data").map((item) => {
      if (item.get("access")) {
        access = access.set(item.get("menu-id"), item.get("menu-id"));
      }
    });
  }
  setAppCookies(obj);
  setAppMenuCookies(access);
}

export function SetUserLogout() {
  cookies.remove(KeyUserLoginEnc);
  cookies.remove(KeyUserMenuAccess);
}

function setAppCookies(obj) {
  var ciphertext = CryptoAES.encrypt(
    JSON.stringify(obj),
    "QWERTYU!#$$%^&&FGHJKL"
  );
  cookies.set(KeyUserLoginEnc, ciphertext.toString());
}

function getAppCookies() {
  var cookieText = cookies.get(KeyUserLoginEnc);
  if (cookieText != undefined) {
    var ciphertext = CryptoAES.decrypt(cookieText, "QWERTYU!#$$%^&&FGHJKL");
    var strObj = ciphertext.toString(CryptoENC);
    var obj = JSON.parse(strObj);
    return obj;
  }
}

function setAppMenuCookies(obj) {
  var ciphertext = CryptoAES.encrypt(
    JSON.stringify(obj),
    "QWERTYU!#$$%^&&FGHJKL"
  );
  cookies.set(KeyUserMenuAccess, ciphertext.toString());
}

function getAppMenuCookies() {
  var cookieText = cookies.get(KeyUserMenuAccess);
  if (cookieText != undefined) {
    var ciphertext = CryptoAES.decrypt(cookieText, "QWERTYU!#$$%^&&FGHJKL");
    var strObj = ciphertext.toString(CryptoENC);
    var obj = JSON.parse(strObj);
    return obj;
  }
}
